import { toast } from "react-toastify";
import { Flip} from "react-toastify";



const successMessage = (message, messageAr, pendingMessage) => {
  toast.update(pendingMessage, {
    render: messageAr,
    type: "success",
    position: "bottom-right",
    isLoading: false,
    transition: Flip,
    autoClose: 3000,
  });
};

export default successMessage;
